import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { JssNavItem } from '@core/jss-models';
import { JssRouteBuilderService } from '@core/jss-routing';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { GenericLinkDirective } from '@core/jss-utils';
import { TrackLinkDirective } from '@analytics/events';
import { ListItemComponent } from '@legacy/common-ui-partials';

@Component({
  selector: 'wl-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: [
    './sidebar-nav.component.essent.scss',
    './sidebar-nav.component.ed.scss',
  ],
  standalone: true,
  imports: [
    NgClass,
    AutomationIdDirective,
    GenericLinkDirective,
    TrackLinkDirective,
    ListItemComponent,
  ],
})
export class SidebarNavComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() items?: JssNavItem[];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() language?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() topNavigation = false;

  @Output()
  navItemClick = new EventEmitter<JssNavItem>();

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showCategories?: boolean;

  componentData = {
    fields: {
      componentName: {
        value: 'sidebar',
      },
    },
  };

  constructor(
    private readonly urlBuilder: JssRouteBuilderService,
    public router: Router
  ) {}

  getRouteUrl(navItem: JssNavItem, language: string) {
    return this.urlBuilder.createRouteData(navItem, language);
  }
}
